angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "");
}]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-ui-bootstrap/template/tooltip/tooltip-html-popup.html.js
// module id = 587
// module chunks = 1